import {
    Component,
    Input,
    TemplateRef,
    ContentChild,
    OnInit,
    OnChanges,
    SimpleChanges,
    Inject,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, distinctUntilChanged } from 'rxjs/operators';

import { ThemeService } from 'src/app/services/ThemeService';

@Component({
    selector: 'stAccordion',
    templateUrl: './st-accordion.template.html',
    styleUrls: ['./st-accordion.component.scss'],
    standalone: false
})
export class StAccordionComponent implements OnInit, OnChanges {
    private destroy$ = new Subject<void>();
    @ContentChild('contentTemplate') contentTemplate: TemplateRef<any>;
    @Input() items: any[];
    @Input() cardClass: string;
    @Input() innerId: string = 'st-accordion';
    @Input() activeIds: string[] | 'all' | 'first' = 'all';

    public actualActiveIds: string[];
    public theme: string;

    constructor(@Inject(ThemeService) private themeService: ThemeService) {}

    ngOnInit() {
        this.theme = this.themeService.theme.id;

        this.themeService.themeObs$
            .pipe(takeUntil(this.destroy$), distinctUntilChanged())
            .subscribe((theme) => {
                if (theme) {
                    this.theme = this.themeService.theme.id;
                }
            });

        if (this.activeIds === 'all') {
            this.actualActiveIds = this.items.map((_, index) => `${this.innerId}-${index}`);
        }
        if (this.activeIds === 'first') {
            this.actualActiveIds = [`${this.innerId}-0`];
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items && !changes.items.firstChange) {
            this.items = changes.items.currentValue;
            if (this.activeIds === 'all') {
                this.actualActiveIds = this.items.map((_, index) => `${this.innerId}-${index}`);
            }
            if (this.activeIds === 'first') {
                this.actualActiveIds = [`${this.innerId}-0`];
            }
        }
    }

    updateActiveIds() {
        this.actualActiveIds = this.items.map((_, index) => `${this.innerId}-${index}`);
    }
}
